
//
// Live Search Controller
//
// Marries the live-search input, voucher table, and modals which are summoned
// in response to exact matching a voucher code in the search box.
//

module.exports = function LiveSearchController ($page, $$) {

  // Modals
  var redeemModal = getWidgetAtDom($$('[data-widget="redeem-modal"]'));
  var errorModal  = getWidgetAtDom($$('[data-widget="error-modal"]'));

  // Gather widgets
  var input       = getWidgetAtDom($$('[data-widget="live-input"]'));
  var sort        = getWidgetAtDom($$('[data-widget="sort-triggers"]'));
  var table       = getWidgetAtDom($$('[data-widget~="filter-table"]'));

  // Functions
  function dispatchCorrectModal (row) {

    switch (row.data.display_status) {
      case "valid":
        redeemModal.invoke({
          title:      "Confirm Redemption",
          text:       row.data.voucher_title ? (row.data.voucher_code + " - " + row.data.voucher_title) : row.data.voucher_code,
          code:       row.data.voucher_code,
          status:     row.data.display_status,
          voucher_id: row.data.voucher_id,
        }); break;

      case "expired":
        if (row.isRedeemable()) {
          redeemModal.invoke({
            title:      "Voucher Expired",
            text:       row.data.voucher_code + " - " + row.data.expired_time,
            code:       row.data.voucher_code,
            status:     'expired',
            voucher_id: row.data.voucher_id,
          }); break;
        } else {
          errorModal.invoke({
            title: "Voucher Expired",
            text: "This voucher " + row.data.expired_time.toLowerCase() + ".<br> If you still wish to redeem it, please log in as a manager.",
            action: {
              text: "See Voucher",
              href: "/admin/vouchers/view/" + row.data.voucher_code + "/" + row.data.voucher_id
            }
          }); break;
        }

      case "redeemed":
        errorModal.invoke({
          title: "Error",
          text: "Already redeemed on " + formatDateHumanShort(row.data.redemption_date),
          action: {
            text: "See Voucher",
            href: "/admin/vouchers/view/" + row.data.voucher_code + "/" + row.data.voucher_id
          }
        }); break;

      case "void":
        errorModal.invoke({
          title: "Error",
          text: "Voided on " + formatDateHumanShort(row.data.void_date) + " by " + row.data.void_operator_name + "<br>" + "\"" + row.data.void_reason + "\"",
          action: {
            text: "See Voucher",
            href: "/admin/vouchers/view/" + row.data.voucher_code + "/" + row.data.voucher_id
          }
        }); break;
    }

    input.clear();
  }

  // Listeners
  sort.onUpdate(table.sortByKey);
  input.onChange(table.filter);
  table.onExactMatch(dispatchCorrectModal);

  // Redirect stray keystrokes to search field
  document.addEventListener('keypress', function (event) {
    if (event.target.tagName !== 'INPUT') {
      input.focusWithKeystroke(event.key);
    }
  });

  // Init
  input.focus();

};

